import eventFrequencyDataset from "../datasets/event_frequency_dataset";

export const rptFrequencyAnalysisSummary = (eventsData) => {
    let rptArr = [];
    let eventArr = [];
    for (let i=0; i<eventsData.length; i++){
        const event = eventsData[i];
        let freqType = "";
        let freqPriority = "";
        if (event.frequencyObj){
            freqType = event.frequencyObj.frequencyType;
            freqPriority = event.frequencyObj.freqPriority;
        }
        const eventObj = {freqType: freqType, freqPriority: freqPriority, frequency: event.frequency};
        eventArr.push(eventObj);
    }
    eventArr = eventArr.sort((a, b) => 
            (a.freqType + a.freqPriority > b.freqType + b.freqPriority) ? 1 : -1);   
    let prevFreqType = "";
    let prevFreqPriority = "";  
    let prevFrequency = "";
    let frequencyCount = 0;
    let freqTypeCount = 0;
    let sortNbr = 0;
    let sortNbr2 = 0;
    for (let i=0; i<eventArr.length; i++){
        if (i === 0){
            const headingLine = {
                frequencyType: "Frequency Type",  
                frequencyTier: "Frequency Tier", 
                frequency: "Frequency Nbr",
                count: "Count",
                sortNbr: 999999 };
            rptArr.push(headingLine);
        }
        const event = eventArr[i];
        if (event.frequency !== prevFrequency){
              if (prevFrequency !== ""){
                    const rptLine = {frequencyType: prevFreqType,
                        frequencyTier: prevFreqPriority,
                        frequency: prevFrequency,
                        count: frequencyCount,
                        sortNbr: +sortNbr,
                    }
                    rptArr.push(rptLine);
              }
              prevFreqPriority = event.freqPriority;
              prevFrequency = event.frequency;
              sortNbr = prevFrequency;
              if (prevFrequency === "force"){
                sortNbr = 9999;
              }
              frequencyCount = 0;
        }
        if (event.freqType !== prevFreqType){
            if (prevFreqType !== ""){
                const currentFreqType = prevFreqType;
                const frequencyObj = eventFrequencyDataset.find(elem => elem.frequency + elem.tier ===
                    currentFreqType + "mid" );
                if (!frequencyObj){
                    sortNbr2 = 10000 + 9999;
                }else{
                    sortNbr2 = 10000 + +frequencyObj.freqNbr;
                }
                const rptLine = {frequencyType: prevFreqType,
                        frequencyTier: "All",
                        frequency: "",
                        count: freqTypeCount,
                        sortNbr: +sortNbr2,
                    }
                    rptArr.push(rptLine);
            }
            prevFreqType = event.freqType;
            freqTypeCount = 0;
        }
        frequencyCount += 1;
        freqTypeCount += 1;
            
    }
    let rptLine = {frequencyType: prevFreqType,
                        frequencyTier: prevFreqPriority,
                        frequency: prevFrequency,
                        count: frequencyCount,
                        sortNbr: +sortNbr
                    }
    rptArr.push(rptLine);
    
    const frequencyObj = eventFrequencyDataset.find(elem => elem.frequency + elem.tier ===
                    prevFreqType + "mid" );
    sortNbr2 = 10000 + +frequencyObj.freqNbr;
    rptLine = {frequencyType: prevFreqType,
                        frequencyTier: "All",
                        frequency: "",
                        count: freqTypeCount,
                        sortNbr: +sortNbr2,
                    }
    rptArr.push(rptLine);

    rptArr.sort((a, b) => (+a.sortNbr > +b.sortNbr) ? -1 : 1); 
         
    return rptArr;
   
}
export default rptFrequencyAnalysisSummary;